// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9deffc01","455":"95df394d"}[chunkId] + ".chunk.js";
};